import{B as f}from"./chunk-BaseElement-COVKFV2h.js";import{W as m}from"./chunk-WithApiClient-CVkX1jbr.js";import{x as l,T as c}from"./chunk-lit-element-CULRVKo8.js";import"./chunk-index-CKJCYK2x.js";const b=`
  query GetDocSection(
    $type: String!
    $handle: String!
    $first: Int
    $after: String
  ) {
    metaobject(handle: { type: $type, handle: $handle }) {
      field(key: "items") {
        references(first: $first, after: $after) {
          nodes {
            ... on Metaobject {
              id
              handle
              type
              title: field(key: "title") {
                value
              }
              docType: field(key: "type") {
                value
              }
              docID: field(key: "document_id") {
                value
              }
              docSpecs: field(key: "specs") {
                value
              }
              pdf: field(key: "pdf") {
                reference {
                  ... on GenericFile {
                    url
                    mimeType
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;class y extends m(f){static get properties(){return{sectionType:{type:String,attribute:"section-type"},handles:{type:String,attribute:"section-handles"},pageSize:{type:Number,attribute:"page-size"},error:{type:String,state:!0},items:{type:Array,state:!0},page:{type:Number,state:!0}}}constructor(){super(),this.error=""}connectedCallback(){if(super.connectedCallback(),!this.handles||!this.sectionType)return;const e=new URL(window.location.href),s=parseInt(e.searchParams.get("page"),10);!isNaN(s)&&s>0&&(this.page=s),this.load()}async fetchPage({handle:e,after:s}){var t,o,r,n,d;const i=await this.$api.client.storefront({body:{query:b,variables:{type:this.sectionType,handle:e,first:250,after:s}},priority:"high"});if("errors"in i)throw new Error(((o=(t=i.errors)==null?void 0:t[0])==null?void 0:o.message)||"error fetching document section");const a=(d=(n=(r=i.data)==null?void 0:r.metaobject)==null?void 0:n.field)==null?void 0:d.references;return{nodes:(a==null?void 0:a.nodes)??[],pageInfo:(a==null?void 0:a.pageInfo)??{hasNextPage:!1,endCursor:null}}}async fetchAllForHandle(e,s=null,i=[]){const{nodes:a=[],pageInfo:t={hasNextPage:!1,endCursor:null}}=await this.fetchPage({handle:e,after:s}),o=[...i,...a];return t.hasNextPage&&t.endCursor?this.fetchAllForHandle(e,t.endCursor,o):o}async load(){this.error="";try{const e=this.handles.split(",").map(t=>t.trim()).filter(Boolean),i=(await Promise.all(e.map(t=>this.fetchAllForHandle(t)))).flat();this.items=i.sort((t,o)=>{var r,n;return(((r=t==null?void 0:t.title)==null?void 0:r.value)||t.handle).localeCompare(((n=o==null?void 0:o.title)==null?void 0:n.value)||o.handle)});const a=Math.min(Math.max(1,this.page||1),this.totalPages);if(a!==this.page){this.page=a;let t=new URL(window.location.href);t.searchParams.set("page",String(this.page)),window.history.replaceState({},"",t)}}catch(e){this.error=(e==null?void 0:e.message)||String(e)}}get pagedItems(){const e=(this.page-1)*this.pageSize;return this.items.slice(e,e+this.pageSize)}get totalPages(){return Math.ceil(this.items.length/this.pageSize)||1}get rangeText(){const e=this.items.length;if(e===0)return"Showing 0-0 items / 0 Items";const s=(this.page-1)*this.pageSize+1,i=Math.min(s+this.pageSize-1,e);return`Showing ${s}-${i} items / ${e} Items`}goToPage(e){const s=Math.min(Math.max(1,e),this.totalPages);if(s!==this.page){this.page=s;const i=new URL(window.location.href);i.searchParams.set("page",String(this.page)),window.history.replaceState({},"",i),this.scrollIntoView({behavior:"smooth",block:"start"})}}prevPage(){this.goToPage(this.page-1)}nextPage(){this.goToPage(this.page+1)}renderPagination(){const e=this.totalPages,s=this.page,i=[],a=5,t=Math.floor(a/2);let o=Math.max(1,s-t),r=Math.min(e,o+a-1);r-o<a-1&&(o=Math.max(1,r-a+1));for(let n=o;n<=r;n++){const d=n===s;i.push(l`
        <button
          type="button"
          class="transition-[color, border-color] ${d?"cursor-not-allowed":"border-[transparent]"} body-l flex h-[1.5625rem] min-w-5 items-center justify-center border-b-2 text-[0.75rem] text-t-brand-foreground-secondary !no-underline !outline-0 duration-300 ease-out hover:border-t-brand-foreground-secondary hover:text-t-brand-foreground-secondary"
          @click=${()=>this.goToPage(n)}
          ?disabled=${d}
        >
          ${n}
        </button>
      `)}return l`<div class="flex items-center gap-x-[0.9375rem]">${i}</div>`}renderItem(e){var n,d,h,p,g,u;const s=((n=e==null?void 0:e.title)==null?void 0:n.value)||e.handle,i=(h=(d=e==null?void 0:e.pdf)==null?void 0:d.reference)==null?void 0:h.url,a=(p=e==null?void 0:e.docType)==null?void 0:p.value,t=(g=e==null?void 0:e.docSpecs)==null?void 0:g.value,o=(u=e==null?void 0:e.docID)==null?void 0:u.value,{sections:r}=window.shopifyStoreSettings||{};return l`
      <div
        class="border-b border-t-brand-accent-01 pb-7 last:border-0 last:pb-0 lg:flex lg:items-center lg:justify-between lg:gap-x-3.5"
      >
        <div class="flex flex-col gap-y-3.5">
          <h3
            class="h5 break-words font-medium uppercase tracking-[0.03em] text-t-brand-foreground-secondary"
          >
            ${s}
          </h3>
          <div
            class="body-l flex flex-col items-start gap-y-[0.3125rem] text-t-brand-foreground-secondary"
          >
            ${a?l`<span>${r==null?void 0:r.type} ${a}</span>`:c}
            ${o?l`<span>${r==null?void 0:r.id} ${o}</span>`:c}
            ${t?l`<span>${r==null?void 0:r.specs} ${t}</span>`:c}
          </div>
        </div>
        <div class="mt-[0.9375rem] lg:mt-0">
          <a
            href="${i}"
            class="inline-flex items-center justify-center gap-x-2.5 border-2 border-t-brand-accent-02 px-2.5 py-5 text-t-brand-foreground-secondary transition duration-300 ease-out hover:border-t-brand-foreground-secondary hover:bg-t-brand-foreground hover:text-t-brand-foreground-tertiary"
            target="_blank"
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path
                d="M1.94531 4.84419L5.00087 7.85989M5.00087 7.85989L8.05642 4.84419M5.00087 7.85989L5.00087 0.637671"
                stroke="currentColor"
                stroke-width="0.75"
              />
              <line
                x1="1.38867"
                y1="8.9873"
                x2="8.61089"
                y2="8.9873"
                stroke="currentColor"
                stroke-width="0.75"
              />
            </svg>
            <span>${r==null?void 0:r.pdf_download}</span>
          </a>
        </div>
      </div>
    `}render(){return this.error?l`<div class="text-red-600">${this.error}</div>`:l`
      <div>
        <div
          class="flex flex-col gap-y-lg border-b border-t-brand-accent-01 pb-7 pt-lg first:!pt-0 last:border-0 last:pb-0"
        >
          ${this.pagedItems.map(e=>this.renderItem(e))}
        </div>

        ${this.totalPages>1?l`
              <nav class="px-0 pb-xl pt-xs lg:py-xl">
                <div class="flex items-center justify-between">
                  <button
                    @click=${this.prevPage.bind(this)}
                    ?disabled=${this.page===1}
                    class="${this.page===1?"cursor-not-allowed opacity-50":"cursor-pointer"} flex h-10 items-center gap-x-0.5 lg:h-auto"
                  >
                    <svg
                      viewBox="0 0 18 18"
                      fill="none"
                      aria-hidden="true"
                      focusable="false"
                      class="icon-arrow icon w-[18px] rotate-180"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.75 14.5L17.25 9M17.25 9L11.75 3.5M17.25 9L0.750001 9"
                        stroke="currentColor"
                        stroke-width="0.75"
                      />
                    </svg>
                    <span class="hidden lg:block">Prev</span>
                  </button>

                  ${this.renderPagination()}

                  <button
                    @click=${this.nextPage.bind(this)}
                    ?disabled=${this.page===this.totalPages}
                    class="${this.page===this.totalPages?"cursor-not-allowed opacity-50":"cursor-pointer"} flex h-10 items-center gap-x-0.5 lg:h-auto"
                  >
                    <span class="hidden lg:block">Next</span>
                    <svg
                      viewBox="0 0 18 18"
                      fill="none"
                      aria-hidden="true"
                      focusable="false"
                      class="icon-arrow icon w-[18px]"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.75 14.5L17.25 9M17.25 9L11.75 3.5M17.25 9L0.750001 9"
                        stroke="currentColor"
                        stroke-width="0.75"
                      />
                    </svg>
                  </button>
                </div>
                <div class="mt-0.5 text-center">
                  <span
                    class="caption leading-none tracking-[0.03em] text-t-brand-foreground-secondary"
                  >
                    ${this.rangeText}
                  </span>
                </div>
              </nav>
            `:c}
      </div>
    `}}window.customElements.define("documents-list",y);
